export const environment = {
  adobeLaunchScriptSource:
    'https://assets.adobedtm.com/267c22ecc15c/514441733727/launch-6d6aa8954ff7.min.js',
  production: true,
  showProvenueErrorInfo: false,
  apiUrl: 'https://groupsales.service.3ddigitalvenue.com/api',
  oktaData: {
    clientId: '0oarywblm4Q2cVXz6357',
    issuer: 'https://ids.mlb.com/oauth2/aus1m088yK07noBfh356',
  },
  analytics: {
    club: [],
    mmc: '',
  },
  sandboxClient: null as string | null,
  ga4MeasurementId: 'G-W65S7GM9SC',
  debug: false,
};
